import { Building2 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { Select } from '@/components/ui/select';
import { useCompanyScope } from '@/lib/company-context';

/**
 * Selector global de empresa (cabecera). Al cambiar, limpia de la URL la empresa y lo que pertenece a ella
 * (proyecto, asesor, etiqueta, campos personalizados) para que la página use la activa sin filtros pegados.
 */
const COMPANY_BOUND = ['companyId', 'projectId', 'advisorId', 'unassigned', 'tagIds'];

export function CompanySwitcher() {
  const { companies, active, setActive } = useCompanyScope();
  const [params, setParams] = useSearchParams();
  if (companies.length <= 1) return null;
  return (
    <div className="relative hidden items-center sm:flex">
      <Building2 className="text-muted-foreground pointer-events-none absolute left-2.5 h-4 w-4" />
      <Select
        value={active ?? ''}
        onChange={(e) => {
          setActive(e.target.value);
          const next = new URLSearchParams(params);
          for (const k of [...next.keys()])
            if (COMPANY_BOUND.includes(k) || k.startsWith('cf_')) next.delete(k);
          if (next.toString() !== params.toString()) setParams(next, { replace: true });
        }}
        aria-label="Inmobiliaria activa"
        className="h-9 w-48 pl-8 text-xs"
        data-testid="company-switcher"
      >
        {companies.map((c) => (
          <option key={c.companyId} value={c.companyId}>
            {c.companyName}
          </option>
        ))}
      </Select>
    </div>
  );
}
